<template>
  <ValidationObserver>
    <div class="row">
      <div class="col-12 col-lg-3 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate: _validate }"
          :disabled="!validate"
          mode="passive"
          :rules="{ required: true }"
          :custom-messages="{ required: 'Favor seleccione región.' }"
        >
          <CustomDropDown
            v-model="localModel.region"
            :disabled="readonly"
            label="Región:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalog.regions"
            placeholder="Seleccione"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-lg-3 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate: _validate }"
          :disabled="!validate"
          mode="passive"
          :rules="{ required: true }"
          :custom-messages="{ required: 'Favor seleccione municpio.' }"
        >
          <CustomDropDown
            v-model="localModel.municipality"
            label="Municipio:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalog.municipalities"
            placeholder="Seleccione"
            :disabled="readonly || !localModel.region"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-lg-3 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate: _validate }"
          :disabled="!validate"
          mode="passive"
          :rules="{ required: true }"
          :custom-messages="{ required: 'Favor seleccione Escuela.' }"
        >
          <CustomDropDown
            v-model="localModel.locationSchool"
            label="Escuela:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalog.schools"
            placeholder="Seleccione"
            :disabled="readonly || !localModel.municipality"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="_validate($event !== null || true)"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 pt-3">
        <span class="small text-gray">
          Para crear la alternativa de ubicación se identifica:
        </span>
        <div
          :style="{ 'border-top': '1px solid #E2E2E2', margin: '.5rem 0' }"
        />
      </div>
      <div class="col-12">
        <template v-for="(question, i) in catalog.questions">
          <div :key="i" class="pt-2">
            <AlternativeCreationQuestion
              v-model="localModel[question.key]"
              :text="question.text"
              :readonly="readonly"
              :validate="validate"
            />
          </div>
        </template>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import AlternativeCreationQuestion from './_components/AlternativeCreationQuestion';
import { schoolRecommendationCatalogApi } from './_api';

const modelInitialState = () => ({
  locationSchool: null,
  hasLounge: 0,
  hasHumanResourceAttendant: 0,
  hasEquipmentAndMaterials: 0,
  region: null,
  municipality: null,
});

export default {
  name: 'AlternativeCreation',
  components: {
    CustomDropDown,
    AlternativeCreationQuestion,
  },
  props: {
    academicYearId: { type: [Number, String], default: null },
    model: { type: Object, default: modelInitialState },
    readonly: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
  },
  data: () => ({
    catalog: {
      regions: [],
      municipalities: [],
      schools: [],
      questions: [
        {
          text: 'El salón que se utilizará.',
          key: 'hasLounge',
        },
        {
          text: 'El recurso humano que lo atenderá.',
          key: 'hasHumanResourceAttendant',
        },
        {
          text: 'Los equipos y materiales que se necesitan.',
          key: 'hasEquipmentAndMaterials',
        },
      ],
    },
    localModel: modelInitialState(),
    doWatch: false,
  }),
  methods: {
    async getRegions() {
      const data = await schoolRecommendationCatalogApi.getRegions({
        academicYearId: this.academicYearId,
      });
      this.catalog.regions = data;
    },
    async getMunicipalities({ regionId }) {
      if (!regionId) return;
      const data = await schoolRecommendationCatalogApi.getMunicipalities({
        academicYearId: this.academicYearId,
        regionId,
      });
      this.catalog.municipalities = data;
    },
    async getSchools({ regionId, municipalityId }) {
      if (!regionId || !municipalityId) return;

      const data = await schoolRecommendationCatalogApi.getSchools({
        academicYearId: this.academicYearId,
        regionId,
        municipalityId,
      });
      this.catalog.schools = data;
    },
  },
  watch: {
    model: {
      async handler() {
        if (this.doWatch) return;
        this.localModel = this.model;
        if (
          this.model &&
          this.model.region?.id &&
          this.model.municipality?.id
        ) {
          await this.getMunicipalities({ regionId: this.model.region.id });
          await this.getSchools({
            regionId: this.model.region.id,
            municipalityId: this.model.municipality.id,
          });
        }
        this.doWatch = true;
      },
      deep: true,
      immediate: true,
    },
    'localModel.region': {
      async handler(value) {
        if (!this.doWatch) return;
        this.catalog.municipalities = [];
        this.localModel.municipality = null;
        if (!value?.id) return;
        await this.getMunicipalities({ regionId: value?.id });
      },
      deep: true,
    },
    'localModel.municipality': {
      async handler(value) {
        if (!this.doWatch) return;
        this.catalog.schools = [];
        this.localModel.locationSchool = null;
        if (!value?.id || !this.localModel.region?.id) return;
        await this.getSchools({
          regionId: this.localModel.region?.id,
          municipalityId: value?.id,
        });
      },
      deep: true,
    },
    localModel: {
      async handler() {
        this.$emit('update:model', this.localModel);
      },
      deep: true,
    },
  },
  async created() {
    await this.getRegions();
  },
};
</script>
